import { render } from "./QuizSlideViewSuspense.vue?vue&type=template&id=6fb73b7a"
import script from "./QuizSlideViewSuspense.vue?vue&type=script&lang=js"
export * from "./QuizSlideViewSuspense.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\aarhondakis\\Desktop\\lernapp_quellcode\\lernapp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__